module.exports = __webpack_public_path__ + "media/images/emblems/Worben-coat_of_arms-f09c287109e8976098e4dc9093e9fe97.svg";